import type { SalesforceLogException } from '@/types/salesforce';

export const SALESFORCE_LOG_EXCEPTIONS: SalesforceLogException[] = [
  // Lead not found on unsubscribe — handled with custom UI in UnsubscribeModal
  { url: 'apexrest/setLeadOptOut', status: 404, details: 'Lead not found' },
];
